<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-9">                  
                <div class="row mb-5">                    
                    <div class="col-lg-12 mt-lg-0 mt-4">
                        <reference-detail />                        
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import ReferenceDetail from "./components/ReferenceDetail.vue"

export default {
    name: 'Location_edit_page',
    components: {        
        ReferenceDetail
    },
    data() {
        return {
            Id: '',
            reference: [],
            gets: []
        }
    },
    async mounted() {
        this.id = this.$route.params.id;   
        console.log('Route ID:', this.id);   
    },
}
</script>